module.exports = __webpack_public_path__ + "img/logo.b3d19763.png";